import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { TecnicoResponsable } from './entity-tecnico-responsable.model';

export const entityTecnicoResponsableAdapter: EntityAdapter<TecnicoResponsable> =
  createEntityAdapter<TecnicoResponsable>({
    selectId: (model) => model.id,
    sortComparer: (a: TecnicoResponsable, b: TecnicoResponsable): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityTecnicoResponsableState
  extends EntityState<TecnicoResponsable> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityTecnicoResponsableState =
  entityTecnicoResponsableAdapter.getInitialState({
    isLoading: false,
    error: null
  });
